import { Injectable, Injector } from '@angular/core';
import { CoreServiceBase } from '@core/bases/core-service-base';
import { environment } from '../../../environments/environment';
   
@Injectable({ providedIn: 'root' })
export class MapsLoaderService extends CoreServiceBase {

  constructor(
    injector: Injector
  ) {
    super(injector);
  }

  loadApi(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (document.querySelector('script[src*="googleapis.com/maps/api/js"]')) {
        return resolve();
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve();
      };
      script.onerror = (error) => {
        reject(error);
      };
      document.head.appendChild(script);
    });
  }
}
